import { ODataSelect } from "@iconics/core";

export class Solution extends ODataSelect
{
    public Id = "";
    public Name = "";
    public Description = "";
    public IsEnabled = "";
    public ConcurrencyStamp = "";
    public OrderSequence = 0;
    
    override toSelect(): string
    {
        return 'ID,Name,Description,IsEnabled,ConcurrencyStamp,OrderSequence'
    }
}